// extracted by mini-css-extract-plugin
export var label = "_k5-2";
export var slideContainer = "_k5-0";
export var slider = "_k5-1";